// extracted by mini-css-extract-plugin
module.exports = {"category":"category_category__3dUxs","sliderWrap":"category_sliderWrap__eW-dR","selectWrap":"category_selectWrap__1jexV"};